module.exports = __webpack_public_path__ + "img/Variant3.937fe94b.png";